import React from 'react';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import MarkButton from './MarkButton';

function BoldButton() {
  return <MarkButton format="bold" Icon={<FormatBoldIcon fontSize="small" />} />;
}

export default BoldButton;
